import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useFormik } from "formik";
import TextField from '@mui/material/TextField';
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';
import * as yup from "yup";
import { Link, useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../store/common/commonSlice';

const Signup = (props) => {
    const {
        signup_is_loading,
        show_password,
        handleClickShowPassword,
        handleSignUp,
        company_details
    } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let EMAIL_REGX = /^[a-zA-Z0-9._]+@[^\s@]+\.[^\s@]+$/;
    let PASSWORD_REGX = /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[@#$!%*?&])[\w\d@#$!%*?&]{8,16}$/;
    const validationSchema = yup.object().shape({
        first_name: yup.string().trim().required('First Name is required'),
        last_name: yup.string().trim().required('Last Name is required'),
        email: yup.string().trim().matches(EMAIL_REGX, "Invalid email address").required('Email is required'),
        password: yup.string().trim().matches(PASSWORD_REGX, "Passwords do not match: 8-16 Chars, small, caps, special chars and number").required('Password is required'),
        confirm_password: yup.string().trim().required('Re-enter password is required'),
    });

    const handlePassword = (name) => {
        let newValue = name === 'password' ? show_password.password : show_password.confirm_password;
        let payload = {[name]:!newValue}
        handleClickShowPassword(payload);
      }

    const onSubmit = async (values) => {
        if (values.password !== values.confirm_password){
            dispatch(setSnackBar({
                open: true,
                message: "Password and Re-enter Password does not match.",
                severity: "error",
            }));
        }
        else {
            let tmpData = {...values};
            delete tmpData.confirm_password;
            tmpData.company_domain = window.location.hostname;
            let res = await handleSignUp(tmpData);
            if (!res.error){
                navigate('/login');
            }
        }
    };

    const formik = useFormik({
        enableReinitialize : true,
        initialValues : {
            first_name : "",
            last_name : "",
            email : "",
            password : "",
            confirm_password : "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSubmit(values);
        },
    })
  return (
    <Box 
        sx={{
            display:'flex',
            flexDirection:'column',
            height:'100%'
        }}>
            <Box sx={{
                padding:"30px",
                display:'flex',
                flexDirection:'column',
                flex:'1 1 0%'
            }}>
                <Box sx={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center',
                    flex:'1 1 0%'
                }}>
                    <Paper
                    variant="elevation"
                    elevation={1}
                    square={false}
                    sx={{
                        minHeight:{md:'560px',xs:'auto'},
                        height:{md:'auto',xs:'auto'},
                        maxWidth : {md:'900px',xs:'100%'},
                        width: "100%",
                        boxShadow : 'rgba(0, 0, 0, 0.04) 0px 10px 10px 4px',
                        borderRadius : '16px',
                        overflow:'hidden',
                        display : 'flex',
                        flexDirection:{md:'row',xs:'column'},
                        position : 'relative'

                        }}>
                            <Box sx={{
                                width:{md:'50%',xs:'100%'},
                                height:{md:'100%',xs:'8rem'},
                                display:'flex',
                                justifyContent:'center',
                                alignItems : 'center'
                            }}>
                                <img src='/images/login.png' alt='login.png' style={{width:"100%",height:'100%',objectFit:'cover'}}/>
                            </Box>  
                            <Box sx={{
                                width:{md:'50%',xs:'100%'},
                                padding : {md:'20px',xs:'20px'},
                                display:'flex',
                                justifyContent:'center',
                                alignItems : 'center'
                            }}>
                                <Box sx={{
                                    width:"100%"
                                }}>
                                    <Box sx={{
                                        display:'flex',
                                        flexDirection:'column',
                                        justifyContent:'center',
                                        alignItems:'center',
                                        mt:2,
                                        '& .companyLogo' : {
                                            width : '12rem',
                                            objectFit : 'contain'
                                        }
                                    }}>
                                        <a href='/'><img className='companyLogo' src={company_details?.company_logo} alt='logo.png' /></a>
                                    </Box>
                                    <Typography 
                                    align='center' 
                                    variant='h5' 
                                    sx={{
                                        fontWeight:600,
                                        mt:3
                                    }}
                                    >Welcome to {company_details?.name}
                                    </Typography>
                                    <Box mt={2} sx={{
                                        width:'100%'
                                    }}> 
                                        <Typography 
                                        variant='h6' 
                                        sx={{
                                            fontWeight:600
                                        }}
                                        >Sign Up
                                        </Typography>
                                        <form onSubmit={formik.handleSubmit}>
                                            <Box sx={{
                                                '& .MuiTextField-root': { my:{md:1.5,xs:1}},
                                            }}>
                                                <Stack 
                                                display='flex' 
                                                justifyContent= 'space-between'
                                                sx={{
                                                    '& .MuiTextField-root' : {
                                                        width:{md:'49%',xs:'100%'}
                                                    },
                                                    flexDirection : {md:'row',xs:'column'}
                                                }}
                                                >
                                                    <TextField 
                                                        label="First Name" 
                                                        variant="outlined" 
                                                        size='small'
                                                        name="first_name"
                                                        value={formik.values.first_name}
                                                        onChange={formik.handleChange("first_name")}
                                                        onBlur={formik.handleBlur("first_name")}
                                                        error={
                                                            formik.touched.first_name && Boolean(formik.errors.first_name)
                                                        }
                                                        helperText={formik.touched.first_name && formik.errors.first_name}
                                                        />
                                                    <TextField 
                                                        label="Last Name" 
                                                        variant="outlined" 
                                                        size='small' 
                                                        name="last_name"
                                                        value={formik.values.last_name}
                                                        onChange={formik.handleChange("last_name")}
                                                        onBlur={formik.handleBlur("last_name")}
                                                        error={
                                                            formik.touched.last_name && Boolean(formik.errors.last_name)
                                                        }
                                                        helperText={formik.touched.last_name && formik.errors.last_name}
                                                        />
                                                </Stack>
                                            <TextField 
                                                label="Email" 
                                                variant="outlined" 
                                                sx={{width:'100%!important'}}
                                                size='small' 
                                                name="email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange("email")}
                                                onBlur={formik.handleBlur("email")}
                                                error={
                                                    formik.touched.email && Boolean(formik.errors.email)
                                                }
                                                helperText={formik.touched.email && formik.errors.email}
                                                />
                                            <TextField 
                                                id="password" 
                                                label="Password" 
                                                variant="outlined"
                                                type={show_password.password? 'text' : 'password'}
                                                size='small' 
                                                sx={{width:'100%!important'}}
                                                slotProps={{
                                                    input : {
                                                        endAdornment : (
                                                            <InputAdornment
                                                                position="end"
                                                                onClick={() => handlePassword('password')}
                                                                sx={{cursor : "pointer"}}
                                                            >
                                                                {show_password.password ? <VisibilityOff /> : <Visibility />}
                                                            </InputAdornment>
                                                        )
                                                    }
                                                }}
                                                name="password"
                                                value={formik.values.password}
                                                onChange={formik.handleChange("password")}
                                                onBlur={formik.handleBlur("password")}
                                                error={
                                                    formik.touched.password && Boolean(formik.errors.password)
                                                }
                                                helperText={formik.touched.password && formik.errors.password}
                                                />
                                            <TextField 
                                                id="confirm_password" 
                                                label="Re-enter Password" 
                                                variant="outlined"
                                                type={show_password.confirm_password ? 'text' : 'password'}
                                                size='small' 
                                                sx={{width:'100%!important'}}
                                                slotProps={{
                                                    input : {
                                                        endAdornment : (
                                                            <InputAdornment
                                                                position="end"
                                                                onClick={() => handlePassword('confirm_password')}
                                                                sx={{cursor : "pointer"}}
                                                            >
                                                                {show_password.confirm_password ? <VisibilityOff /> : <Visibility />}
                                                            </InputAdornment>
                                                        )
                                                    }
                                                }}
                                                name="confirm_password"
                                                value={formik.values.confirm_password}
                                                onChange={formik.handleChange("confirm_password")}
                                                onBlur={formik.handleBlur("confirm_password")}
                                                error={
                                                    formik.touched.confirm_password && Boolean(formik.errors.confirm_password)
                                                }
                                                helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                                                />
                                            <LoadingButton
                                            sx={{
                                                my:1
                                            }}
                                                size="medium"
                                                type='submit'
                                                loading={signup_is_loading}
                                                variant="contained"
                                                disableElevation
                                                fullWidth
                                            >
                                                <span>Sign Up</span>
                                            </LoadingButton>
                                            </Box>
                                        </form>
                                        <Box my={1} display='flex' justifyContent='center' width='100%'>
                                            <Link to="/login" style={{textDecoration:'none',color:'#000',fontSize:'14px'}}>Already have an account? <span style={{color:'#438FCD',fontWeight:600}}>Log In</span></Link>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>  
                    </Paper>


                </Box>

            </Box>

        </Box>
  )
}

export default Signup
